import { lazyLoad } from '../../../shared/utils/loadable';

export const ProviderConfirmCompletePage = lazyLoad(
  () => import('./index'),
  (module) => module.ProviderConfirmComplete,
);
